'use client'
import React from 'react'
import { useSearchParams, useParams } from 'next/navigation'
import { isString, toString } from 'lodash'

export const useNextQueryParam: (
    key: string,
    defaultValue?: any
) => string | null = (key, defaultValue) => {
    const searchParams = useSearchParams()
    const urlParams = useParams()
    let param = urlParams?.[key] ?? searchParams.get(key)

    param = (isString(param) ? param : param?.[0]) ?? null
    if (!param || param === '')
        return typeof defaultValue !== 'undefined'
            ? toString(defaultValue)
            : null
    try {
        return decodeURIComponent(param)
    } catch {
        return param
    }
}
